module.exports = __webpack_public_path__ + "img/P150T_weapon_43.a4eee291.png";